import React from 'react';

const NotFound = () => (
  <main>
    <div>This page does not exist.</div>
  </main>
);

export default NotFound;
